import { gql } from '@apollo/client';
import { rgba } from "polished";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Web3 from 'web3';
import { ReactComponent as IconETH } from "../images/IconETH.svg";
import { useEthWeb3State } from "../lib/EthWeb3Context";
import provider from '../lib/WalletProvider';
import {
    Balance, color,
    Flex,
    Hidden, radius,
    ScrollView,
    SVG, Text,
    View
} from "./Styles";
const web3 = new Web3(provider);



export default ({ screen, compondYearYield, ethTotalProfit }) => {
    const { t } = useTranslation();

    const { ethMintDropTotal, ethWeb3Api } = useEthWeb3State()

    const Monitor = styled(Flex)`
    > * {
      flex-shrink: 0;
      padding-right: 2em;
      :not(:last-child) {
        border-right: ${screen !== "mobile" && "1px solid " + color.border.sm};
        border-radius: ${screen === "mobile" && radius.lg};
      }
    }
  `;

    return (
        <Flex jcc aic>
            <Hidden mobile>
                <Text scale={7} bold mr={1.5} color={color.iost}>
                    ETH
        </Text>
            </Hidden>

            <ScrollView>
                <Monitor aic px={[1.25, 0.25]} py={[1.5, 2]} gap={[1.25, 2]}>
                    <MonitorItem
                        name={t("运行监控")}
                        data={t("正常运转")}
                        status="normal"
                    />
                    <MonitorItem
                        name={t("托管总量")}
                        data={
                            <>
                                <SVG svg={IconETH} withText fill={color.black} />
                                {ethMintDropTotal ? (
                                    <Balance amount={(Math.floor(ethMintDropTotal * 10000) / 10000).toFixed(4)} units="ETH" />
                                ) : (
                                        t("加载中")
                                    )}
                            </>
                        }
                    />

                    <MonitorItem
                        name={t("总结算利润")}
                        data={
                            <>
                                <SVG svg={IconETH} withText fill={color.black} />
                                <Balance amount={ethTotalProfit && (Math.floor(web3.utils.fromWei(ethTotalProfit) * 10000) / 10000).toFixed(4) || 0} units="vETH" />
                            </>
                        }
                    />

                    <MonitorItem
                        name={t("7 日平均年化")}
                        data={
                            <Flex aic gap={0.5}>
                                <span>{compondYearYield}%</span>
                            </Flex>
                        }
                    />
                </Monitor>
            </ScrollView>
        </Flex>
    );
};

const GET_TOTAL_DIVIDEND = gql`
  {
    totalDividend
  }
`;

const MonitorItem = props => (
    <div>
        <Text scale={-2} mb={0.85} color={color.lightGray}>
            {props.name}
        </Text>
        <Flex aic>
            {props.status && <StatusBall status={props.status} mr={0.5} />}
            {props.data}
        </Flex>
    </div>
);

export const StatusBall = styled(View)`
  background: ${p => p.status === "normal" && color.green};
  box-shadow: 0 0 0 0.25em
    ${p => p.status === "normal" && rgba(color.green, 0.25)};
  display: inline-block;
  width: 0.5em;
  height: 0.5em;
  border-radius: 50%;
`;
